<template>
  <div class="card">
    <div class="unChoose" v-if="isCardRights === 0" @click="chooseCard(1)">
      <span>{{ TLang("点击筛选可用", "card") }}</span>
      <span class="myCard">{{ TLang("福利卡", "card") }}</span>
      <span>{{ TLang("抵扣的商品", "card") }}</span>
    </div>
    <div class="choosed" v-if="isCardRights === 1" @click="chooseCard(0)">
      <span class="chooseIcon">{{ TLang("以下是可用", "card") }}</span>
      <span class="myCard">{{ TLang("福利卡", "card") }}</span>
      <span>{{ TLang("抵扣的商品", "card") }}</span>
      <span class="cancel">{{ TLang("取消", "card") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isCardRights: {
      type: Number,
      required: true
    }
  },
  methods: {
    chooseCard(type) {
      this.$emit("changeCardChoose", type);
    }
  }
};
</script>

<style lang="less" scope>
@375: 320/375;
.card {
  width: 100%;
  box-sizing: border-box;
  padding: 10px * @375 0;
  font-size: 12px * @375;
  color: #333;
  .unChoose {
    width: 100%;
    height: 29px * @375;
    line-height: 29px * @375;
    text-align: center;
    background: rgba(247, 94, 53, 0.1);
    border-radius: 14px * @375;
    .myCard {
      font-weight: 600;
      color: #f4432c;
      margin: 0 5px * @375;
      background: url("../assets/imgs/icon-card.png") left center no-repeat;
      background-size: 18px * @375 auto;
      padding-left: 20px * @375;
    }
  }
  .choosed {
    box-sizing: border-box;
    width: 100%;
    height: 29px * @375;
    line-height: 29px * @375;
    text-align: center;
    background: rgba(247, 94, 53, 0.1);
    border-radius: 14px * @375;
    border: 1px solid #f75e35;
    color: #f4432c;
    .chooseIcon {
      padding-left: 20px * @375;
      background: url("../assets/imgs/icon-choosed.png") left center no-repeat;
      background-size: 15px * @375 auto;
    }
    .myCard {
      font-weight: 600;
      margin: 0 5px * @375;
      background: url("../assets/imgs/icon-card.png") left center no-repeat;
      background-size: 18px * @375 auto;
      padding-left: 20px * @375;
    }
    .cancel {
      margin-left: 10px * @375;
      cursor: pointer;
    }
  }
}
</style>